export const shellyConfig = {
  common: {
    saving: "Saving...",
    online: "Online",
    offline: "Offline",
  },

  step1: {
    title: "Shelly setup",
    subtitle:
      "Connect your Shelly Cloud account to control your relays (electric locks, gates, etc.).",
    connected: "Account connected",
    notConnected: "Not connected",
    credentialsInfo:
      "Find your credentials in the Shelly app: <b>User settings → Cloud authorization key</b>. There you'll see the <b>Server URI</b> and can generate your <b>Auth Key</b>.",
    serverUriPlaceholder: "e.g. shelly-103-eu.shelly.cloud",
    serverUriHelp: "Cloud server assigned to your Shelly account.",
    authKeyPlaceholderSaved: "•••••••• (already saved, optional to change)",
    authKeyPlaceholderNew: "Paste your cloud authorization key",
    authKeyHelpSaved: "You can leave it empty if you already have a saved key.",
    authKeyHelpNew:
      "This key lets you control your devices: keep it safe.",
    testing: "Testing...",
    testConnection: "Test connection",
    saveCredentials: "Save credentials",
  },

  step2: {
    title: "Device selector for this property",
    subtitle:
      "Select only the Shelly relays that apply to <b>this property</b>. Then, in the PMS you'll see only the selected ones.",
    selectedCount: "{count} selected",
    hintCredentials:
      "Enter your Server URI and Auth Key and click <b>Test connection</b> to load your devices.",
    noDevices: "No devices found in your Shelly account.",
    selectPlaceholder: "Select devices…",
    devicesSelected: "{count} device(s) selected",
    noneSelected: "No devices selected",
    channels: "{count} channels",
    saveDevices: "Save devices for this property",
  },

  step3: {
    title: "Control and assignment (PMS)",
    subtitle:
      "Assign each relay to <b>Main door</b>, <b>Unit</b> or <b>Gate</b> and set the opening pulse.",
    assignedCount: "{count} assigned",
    noSavedDevices:
      "You don't have any saved devices for this property yet. Use the <b>Selector</b> above and then save.",
    pulseInfo:
      "<b>Open</b> sends a pulse to the relay (it turns on and off by itself after the configured seconds): ideal for electric locks and gates. Shelly doesn't generate PIN codes.",
    open: "Open",
    openTooltip: "Open (pulse)",
    turnOnTooltip: "Turn relay on",
    turnOffTooltip: "Turn relay off",
    refreshTooltip: "Refresh status",
    assignment: "Assignment",
    assignNone: "Unassigned",
    assignCommon: "Main door (shared)",
    assignUnit: "Apartment door",
    assignGate: "Gate / Garage",
    hintNone: "It won't be controlled from the PMS.",
    hintAssigned: "It will be linked to this property for remote opening.",
    unitLabel: "Unit / Accommodation",
    selectUnit: "Select a unit",
    unitFallback: "Unit {id}",
    selectUnitHint: "Choose which unit this relay opens.",
    channelLabel: "Relay channel",
    channelOption: "Channel {n}",
    channelHint: "Channel wired to the lock (multi-relay devices).",
    pulseLabel: "Opening pulse (seconds)",
    pulseHint: "How long the relay stays on when opening.",
    nameLabel: "Name (optional)",
    namePlaceholder: "e.g. Main door / Apt 101",
    nameHint: "Name shown in the PMS for this device.",
    saveAssignment: "Save assignment",
    tip:
      "Tip: Assign each relay and click <b>Save assignment</b>. The control buttons are enabled once the device is assigned.",
  },

  toast: {
    loadDevicesFailed: "Devices couldn't be loaded",
    loadDevicesError: "Error loading devices",
    missingCredentials: "You must enter the Server URI and your Shelly Auth Key.",
    connectionSuccess:
      "Connection successful. {count} device(s) found.",
    testError: "Error testing the connection",
    invalidAuthKey: "You must enter a valid Auth Key (at least 10 characters).",
    missingServerUri: "You must enter the Server URI of your Shelly account.",
    credentialsSaved: "Credentials saved successfully",
    credentialsError: "Error saving credentials",
    credentialsSaveError: "Error saving credentials: {error}",
    selectAtLeastOne:
      "You must select at least one device for this property.",
    devicesSaved: "Devices saved for this property",
    devicesSaveFailed: "Devices couldn't be saved",
    saveError: "Error saving: {error}",
    selectUnitForApartment:
      "Select the unit for relays assigned as 'Apartment door'.",
    assignmentFailed: "The assignment couldn't be saved",
    assignmentSaved: "Assignment saved successfully",
    assignmentSaveError: "Error saving assignment: {error}",
    opOpen: "Opening sent (relay pulse)",
    opOn: "Relay on",
    opOff: "Relay off",
    opDone: "Action completed",
    opFailed: "The action couldn't be completed",
    opError: "Error running the action",
  },
};
